import Head from 'next/head'
import Script from 'next/script'
import Image from 'next/image'
import { s3Static } from '../../../utils/constants'
import { getArticleDateTime } from '../../../utils/article-date-time'
import { BlogsList } from '../../../components/blogs/BlogList'
import { blogsMaster } from '../../../utils/sg-blogs-data'
import { getRequestJSON } from '../../../api/index/location-api'
import Link from 'next/link'
import { Carousel } from 'react-responsive-carousel'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { FaCheckCircle, FaStar, FaWhatsapp } from 'react-icons/fa'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useRef, useState } from 'react'
import { RequestProvider } from '../../../context/RequestContext'
import { Services } from '../../../components/index/service/Services'
import { AnimatePresence, motion } from 'framer-motion'
import { getWpNewHouseKeeping, setWpNewHouseKeeping } from '../../../service/wp-blogs-store'
import { getWpNewPostsByCategory } from '../../../lib/service'
import { PartTimeHelperBooking } from '../../../components/index/service-category/domestic-service/PartTimeHelperBooking'
import { getAppSettings } from '../../../api/app-setting/app-setting'
import { DeepCleanBooking } from '../../../components/index/service-category/domestic-service/DeepCleanBooking'
import { openModal } from '../../../service/modal-service'
import { SystemError } from '../../../components/error/SystemError'
import { FcGoogle } from "react-icons/fc";
import { FaKitchenSet } from "react-icons/fa6";
import { MdBalcony, MdOutlineBathroom, MdOutlineBedroomParent, MdOutlineLiving } from 'react-icons/md'
import { moveOutCleaningTestimonials } from '../../../data/CustomerReviewData'
import { CustomerReviews } from '../../../components/index/commons/CustomerReviews'
import { HelperWhyChooseUs } from '../../../components/index/service-category/domestic-service/HelperWhyChooseUs'
import { Badge } from '@/components/ui/badge'
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';
import { Sparkles, Home, Building2, Warehouse } from 'lucide-react';

const pricingData = [
  { type: 'HDB', min: 400, max: 600 },
  { type: 'Condo', min: 500, max: 650 },
  { type: 'Landed', min: 600, max: 800 },
];

export async function getStaticProps() {
    const countryCd = "sg"
    const countryName = "Singapore"
    
    const allRequestCategorySettings = await getRequestJSON(countryName)

    const requestCategorySettings = allRequestCategorySettings.filter(category => category.requestType === "Domestic Services")
    
    const lat = 1.3521
    const lng = 103.8198

    const { modifiedDate, month, year } = getArticleDateTime()
    const houseKeepingBlogs = blogsMaster['house-keeping'].blogArray;
    const wpNewPosts = getWpNewHouseKeeping().length > 0 ?  getWpNewHouseKeeping() : await getWpNewPostsByCategory(6, "house-keeping");
    setWpNewHouseKeeping(wpNewPosts)

    const currencyCd = "SGD"

    return {
        props: {
            requestCategorySettings,
            modifiedDate,
            month,
            year,
            houseKeepingBlogs,
            currencyCd,
            moveOutCleaningTestimonials,
            wpNewPosts,
            countryName
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 259200, // In seconds
    }
}
export default function MoveOutCleaning(props) {
    const router = useRouter()
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const houseKeepingBlogs = props.houseKeepingBlogs
    const wpNewPosts = props.wpNewPosts
    const requestCategorySettings = props.requestCategorySettings;
    const testimonials = props.moveOutCleaningTestimonials
    const maxRating = [1, 2, 3, 4, 5]
    const requestType = 'Domestic Services'
    const countryName = props.countryName
    const currencyCd = props.currencyCd

    const [ requestForm, setRequestForm ] = useState(router.query.requestForm)
    const [ waInd, setWaInd ] = useState(false)
    const [ isQuickBook, setIsQuickBook ] = useState(false)
    const [ openIndex, setOpenIndex ] = useState(null);

    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""})

    const cleaningTools = [
        { icon: "🧹", name: "Vacuum Cleaner", desc: "Removes dust, dirt, and debris from floors and surfaces.", type: "Dry" },
        { icon: "🧽", name: "Microfiber Cloths", desc: "Absorbent and effective at capturing dust and grime.", type: "Dry" },
        { icon: "🪣", name: "Mop and Bucket", desc: "Used for cleaning hard floors, such as tile or wood.", type: "Wet" },
        { icon: "🪥", name: "Scrub Brushes", desc: "Helps in scrubbing tough stains and grime from surfaces.", type: "Wet" },
        { icon: "🪟", name: "Squeegee", desc: "Used for cleaning windows and glass surfaces.", type: "Wet" },
        { icon: "🧴", name: "Spray Bottles", desc: "Contains cleaning solutions for various surfaces.", type: "Multipurpose" },
        { icon: "🕸️", name: "Duster", desc: "Used for dusting surfaces such as furniture and shelves.", type: "Dry" },
        { icon: "🧺", name: "Cleaning Caddies", desc: "Holds cleaning supplies and tools for easy transport.", type: "Multipurpose" },
        { icon: "📏", name: "Extension Poles", desc: "Extends the reach for cleaning high or hard-to-reach areas.", type: "Dry" },
        { icon: "🌫️", name: "Steam Cleaner", desc: "Utilizes steam to sanitize and clean various surfaces.", type: "Wet" },
        { icon: "🔬", name: "Grout Brush", desc: "Specifically designed for cleaning grout lines.", type: "Wet" },
        { icon: "🧼", name: "Carpet Extractor", desc: "Used for deep cleaning carpets and rugs.", type: "Wet" },
        { icon: "🧪", name: "Disinfectant Solution", desc: "Kills germs and bacteria on surfaces.", type: "Multipurpose" },
        { icon: "🧤", name: "Gloves", desc: "Protects hands from chemicals and germs.", type: "Multipurpose" },
        { icon: "🧹", name: "Dustpan and Brush", desc: "Collects debris swept from floors.", type: "Dry" },
    ];

    const typeColors = {
        Dry: "bg-blue-100 text-blue-800",
        Wet: "bg-green-100 text-green-800",
        Multipurpose: "bg-purple-100 text-purple-800",
    };

    useEffect(() => {
        setRequestForm(router.query.requestForm)
    }, [router.query.requestForm])

    const videoRef = useRef();

    useEffect(() => {    
        if(requestForm) return
        videoRef.current.play()
    }, [requestForm])

    const fetchAppSetting = useCallback(async() => {
        try {
            const appSettings = await getAppSettings(countryName)
            setWaInd(appSettings.waBusinessInd)
        } catch (error) {
            console.log(error);
        }
    }, [countryName])

    useEffect(() => {
        if(!countryName) return

        fetchAppSetting()
    }, [countryName, fetchAppSetting])

    const showJobScope = () =>{
        setErrorContent({'header': "Service Inclusions", 'isInfo': true, 'body': "All Rooms - Wipe all surfaces, including aircon. Clean windows, frames, and sills. Wipe cabinet interiors and shelves if empty. Clean ceiling fans and light fixtures. Vacuum and mop.\n\nKitchen - Clean sinks, dining tables, walls, kitchen appliances, dispose of garbage bags.\n\nBathrooms - Clean toilet bowls, bathtub/shower, glass surfaces, mirrors, basin, tap, ventilation fan, floor, drains, wall tiles, and door. Wipe racks and drawers if empty. Dispose of garbage bags.\n\nBedrooms - Wipe racks and drawers if empty. Dispose of garbage bags.\n\nOther - Wipe glass windows, metal grilles (if any), and clean washing machine exterior."});
        openModal(setIsSystemError)
    }

  return (
    <>
      <Head>
        <title>Move Out Cleaning Singapore | End of Tenancy & Move In Services</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Need end-of-tenancy or move-in cleaning in Singapore? Our expert cleaners ensure your property is spotless for handover or move-in. Book today!"/>
        <meta name="keywords" content="Move In Move Out Cleaning Service In Singapore"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/part-time-cleaner-singapore/move-in-move-out-cleaning" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Move Out Cleaning Singapore | End of Tenancy & Move In Services`}/>
        <meta property="og:description" content="Need end-of-tenancy or move-in cleaning in Singapore? Our expert cleaners ensure your property is spotless for handover or move-in. Book today!" />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-21T07:30:46+00:00" />
        <meta property="article:modified_time" content={modifiedDate} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/part-time-cleaners-singapore.jpg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/part-time-cleaners-singapore.jpg" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/part-time-cleaner-singapore/move-in-move-out-cleaning"/>
        <meta name="twitter:title" content={`Move Out Cleaning Singapore | End of Tenancy & Move In Services`}/> 
        <meta name="twitter:description" content="Need end-of-tenancy or move-in cleaning in Singapore? Our expert cleaners ensure your property is spotless for handover or move-in. Book today!"/>
        <link rel="icon" href="/favicon.ico" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/move-in-move-out-cleaning"},"headline":"Move Out Cleaning Singapore | End of Tenancy & Move In Services","description":"Need end-of-tenancy or move-in cleaning in Singapore? Our expert cleaners ensure your property is spotless for handover or move-in. Book today!","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/blog/living/part-time-helper/part-time-cleaners-singapore.jpg"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-21T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/","name":"Home","url":"https://www.stringssg.com/"}},{"@type":"ListItem","position":2,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore","name":"Part Time Cleaner Singapore","url":"https://www.stringssg.com/sg/part-time-cleaner-singapore"}},{"@type":"ListItem","position":3,"item":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/part-time-cleaner-singapore/move-in-move-out-cleaning","name":"Move In Move Out Cleaning","url":"https://www.stringssg.com/sg/part-time-cleaner-singapore/move-in-move-out-cleaning"}}]}]}`
          }}
        />
        <link rel="canonical" href="https://www.stringssg.com/sg/part-time-cleaner-singapore/move-in-move-out-cleaning"/>
        </Head>
        <section id="professional-house-cleaning-singapore" className='relative'>
            <div className="-mt-14 relative w-full aspect-video sm:h-180 overflow-hidden">
                {/* Mobile Video */}
                <video
                    ref={videoRef}
                    className="absolute inset-0 w-full h-full object-cover sm:hidden"
                    poster={s3Static + "blog/living/part-time-helper/housekeeping-1920-1080.jpg"}
                    title="Professional House Cleaning Singapore"
                    muted
                    loop
                    playsInline
                    preload="metadata"
                >
                    <source src="/video/part-time-helper-web.mp4" />
                    <source src="/video/part-time-helper-web.mov" />
                </video>

                {/* Desktop Image */}
                <Image
                    src={s3Static + "blog/living/part-time-helper/part-time-cleaners-singapore.jpg"}
                    fill
                    className="hidden sm:block object-cover"
                    alt="Professional house cleaning in Singapore"
                    priority={false}
                    quality={100}
                    sizes="100vw"
                />
            </div>
            <RequestProvider>
                <div id="campaign" className='relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2'>
                    <DeepCleanBooking requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} setIsQuickBook={setIsQuickBook} countryName={countryName} currencyCd={currencyCd} deepCleanType="Quick Booking - Home Cleaning" showJobScope={showJobScope} serviceType="Spring cleaning"/>
                </div> 
                {requestForm &&
                    <Services requestType={requestType} requestCategorySettings={requestCategorySettings} setRequestForm={setRequestForm} isQuickBook={isQuickBook} asSheet/>
                }      
            </RequestProvider>  
        </section>
        <section className="max-w-5xl mx-auto py-16 px-4 space-y-16">
            <header className="text-center space-y-4">
                <h1 className="text-3xl md:text-4xl font-bold uppercase">
                Move In / Move Out Cleaning Services Singapore
                </h1>
                <p className="text-gray-600 max-w-3xl mx-auto text-base md:text-lg">
                Professional end-of-lease and relocation cleaning for HDB, condo, and landed properties across Singapore. Leave your home spotless—whether you&apos;re handing over or moving in.
                </p>
            </header>

            {/* Move-Out Section */}
            <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="space-y-5 leading-relaxed">
                    <h2 className="text-2xl md:text-3xl font-semibold text-orange-600">What is Move-Out or End of Tenancy Cleaning?</h2>
                    <p>
                        In Singapore, most tenancy agreements require tenants to perform a professional <strong>move-out cleaning</strong> before handing over the property. This is essential to ensure deposit refund and meet landlord expectations.
                    </p>
                    <p>
                        Move-out cleaning is a thorough deep cleaning service that covers every corner of the property—from removing built-up grime to disinfecting bathrooms and kitchens. It goes beyond regular cleaning to ensure the space is left in pristine condition for the next tenant.
                    </p>
                </div>
                <div className="relative h-80 md:h-96">
                    <Image
                        className="rounded-xl shadow-lg"
                        src={s3Static + "blog/living/part-time-helper/Cleaning team with brooms and vacuum cleaner.jpg"}
                        fill
                        style={{ objectFit: "cover" }}
                        alt="End of tenancy cleaning team Singapore"
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                        quality={90}
                    />
                </div>
            </div>

            {/* Move-In Section */}
            <div className="grid md:grid-cols-2 gap-8 items-center">
                <div className="relative h-80 md:h-96 order-last md:order-first">
                    <Image
                        className="rounded-xl shadow-lg"
                        src={s3Static + "blog/living/part-time-helper/home-cleaner-clip-art.jpg"}
                        fill
                        style={{ objectFit: "cover" }}
                        alt="Part-time helper preparing for move-in cleaning"
                        placeholder="blur"
                        blurDataURL={s3Static + "placeholder.png"}
                        quality={90}
                    />
                </div>
                <div className="space-y-5 leading-relaxed">
                    <h2 className="text-2xl md:text-3xl font-semibold text-green-600">What is Move-In Cleaning?</h2>
                    <p>
                        <strong>Move-in cleaning</strong> ensures your new home is spotless and sanitized before you unpack. It’s essentially the same deep clean as move-out cleaning, but focused on welcoming a new tenant or owner into a hygienic environment.
                    </p>
                    <p>
                        Our expert cleaning crew will handle everything—dusting, mopping, kitchen degreasing, bathroom sanitation—so you start fresh in a clean, stress-free space. Perfect for new homeowners, tenants, and landlords preparing a property.
                    </p>
                </div>
            </div>
        </section>             
        <section className="max-w-5xl mx-auto my-16 px-4 space-y-8">
    <motion.h2 
    className="text-2xl md:text-3xl font-bold text-center uppercase"
    initial={{ opacity: 0, y: 30 }} 
    animate={{ opacity: 1, y: 0 }} 
    transition={{ duration: 0.6 }}
    >
    Move Out Cleaning Price in Singapore
    </motion.h2>

    <motion.div 
    className="space-y-6"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    transition={{ staggerChildren: 0.2 }}
    >
    <motion.div className="text-base md:text-lg leading-8 text-gray-700 space-y-4" variants={{ visible: { opacity: 1, y: 0 }, hidden: { opacity: 0, y: 30 } }}>
        <p>
        The average cost of a <strong>move-out cleaning service</strong> in Singapore varies depending on the property type:
        </p>
        <ul className="space-y-3">
        <li className="flex items-center gap-3">
            <Badge className="bg-green-100 text-green-700 px-3 py-1 rounded-full flex items-center gap-1">
            <Home size={16} /> HDB
            </Badge>
            <span>From S$400 – S$600</span>
        </li>
        <li className="flex items-center gap-3">
            <Badge className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full flex items-center gap-1">
            <Building2 size={16} /> Condo
            </Badge>
            <span>From S$500 – S$650</span>
        </li>
        <li className="flex items-center gap-3">
            <Badge className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full flex items-center gap-1">
            <Warehouse size={16} /> Landed
            </Badge>
            <span>From S$600 – S$800</span>
        </li>
        </ul>
    </motion.div>

    <motion.div className="text-base md:text-lg leading-8 text-gray-700 space-y-4" variants={{ visible: { opacity: 1, y: 0 }, hidden: { opacity: 0, y: 30 } }}>
        <p>
        At <strong>StringsSG</strong>, we use <strong>real-time data</strong> and your exact floor size to calculate the most accurate pricing—unlike others who rely on ranges.
        </p>
        <p>
        Our pricing reflects <strong>market trends, demand levels, and availability</strong>, ensuring you get the best rate for your specific requirements.
        </p>
    </motion.div>

    <motion.div className="bg-gray-50 p-6 rounded-xl shadow-md" variants={{ visible: { opacity: 1, y: 0 }, hidden: { opacity: 0, y: 30 } }}>
        <h3 className="text-lg font-semibold text-center mb-4">Estimated Price Range by Property Type</h3>
        <ResponsiveContainer width="100%" height={250}>
        <BarChart data={pricingData}>
            <XAxis dataKey="type" />
            <YAxis />
            <Tooltip formatter={(value) => [`S$${value}`, 'Price']} />
            <Bar dataKey="min" fill="#fdba74" name="Min Price" />
            <Bar dataKey="max" fill="#ea580c" name="Max Price" />
        </BarChart>
        </ResponsiveContainer>
    </motion.div>

    <motion.div className="text-center pt-6 w-full flex justify-center" variants={{ visible: { opacity: 1, y: 0 }, hidden: { opacity: 0, y: 30 } }}>          
        <button
            type="button"
            onClick={() => scrollTo({ top: 0, behavior: 'smooth' })}
            className="flex justify-center items-center py-3 px-6 rounded-full bg-linear-to-tr from-orange-600 to-amber-400 text-white font-semibold shadow hover:scale-105 transition-transform duration-200"
        >
            <Sparkles size={18} />&nbsp;Get My Instant Quote
        </button>
    </motion.div>
    </motion.div>
</section>
        <section className="max-w-5xl mx-auto py-12 px-4">
            <h2 className="text-2xl md:text-3xl font-bold text-center uppercase mb-10">
                What&apos;s Included in Our Cleaning Services?
            </h2>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {[
                {
                    icon: <MdOutlineLiving className="text-5xl text-orange-500" />, 
                    title: "Living Area",
                    desc: "Wipe all surfaces, clean aircon exterior, windows, shelves, ceiling fans, vacuum and mop the floor."
                },
                {
                    icon: <MdOutlineBedroomParent className="text-5xl text-orange-500" />, 
                    title: "Bedrooms",
                    desc: "Clean all surfaces, windows, cabinets, dispose trash, vacuum and mop."
                },
                {
                    icon: <FaKitchenSet className="text-5xl text-orange-500" />, 
                    title: "Kitchen",
                    desc: "Wipe surfaces, clean appliances, cabinets, dining areas, and mop floors."
                },
                {
                    icon: <MdOutlineBathroom className="text-5xl text-orange-500" />, 
                    title: "Bathrooms",
                    desc: "Scrub toilets, basins, mirrors, walls, tiles, floors, and replace trash bags."
                },
                {
                    icon: <MdBalcony className="text-5xl text-orange-500" />, 
                    title: "Balcony",
                    desc: "Mop balcony, wipe glass windows, metal grilles (if any), and clean washing machine exterior."
                },
                {
                    icon: <FaCheckCircle className="text-5xl text-orange-500" />, 
                    title: "Others",
                    desc: "Additional cleaning requests or miscellaneous items will be evaluated and quoted individually. Our team ensures flexibility to meet your household needs."
                }
                ].map(({ icon, title, desc }, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition duration-300 text-center space-y-4 touch-manipulation">
                    <div className="flex justify-center">{icon}</div>
                    <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{desc}</p>
                </div>
                ))}
            </div>
        </section>
        <HelperWhyChooseUs />
        <section className="bg-white py-16 px-4">
            <div className="max-w-6xl mx-auto text-center">
                <h2 className="text-2xl md:text-3xl font-bold uppercase text-gray-800 mb-4 leading-relaxed">
                    What Customers Say About Our Move-in Move-out Cleaning Services
                </h2>
                <p className="text-gray-600 mb-10 max-w-3xl mx-auto">
                    Real feedback from homeowners and businesses who trust <strong>StringsSG for home cleaning service in Singapore</strong>. Quality, speed, and customer satisfaction — all in one place.
                </p>
                <div className="flex justify-center items-center space-x-3 mb-4">
                    <Image
                        className="rounded-xl"
                        src={s3Static + "google-icon.png"}
                        height={45}
                        width={80}
                        style={{ objectFit: 'contain', objectPosition: 'center' }}
                        alt="Google Review for Aircon Servicing Singapore - StringsSG"
                    />
                    <div className="flex items-center space-x-1">
                        <span className="text-lg font-bold text-gray-500">4.8</span>
                        <span className="text-2xl text-amber-400">
                        <FaStar />
                        </span>
                    </div>
                </div>
                <CustomerReviews testimonials={testimonials} />
            </div>
        </section>
        <div className='fixed bottom-2 w-full text-center z-10 flex justify-center space-x-5'>
            {/* <a href={waInd ? "https://wa.me/6593512695" : "https://wa.me/6588491419" } target="_blank" rel="noreferrer" className='flex items-center text-white py-2 px-4 rounded-full bg-gradient-to-tl from-green-700 to-green-500 font-bold space-x-1'>
                <div>Chat</div>
                <FaWhatsapp className='text-2xl'/>
            </a> */}
        </div>
        <section className="max-w-5xl mx-auto my-20 px-4 space-y-6">
            <h2 className="text-2xl md:text-3xl font-bold uppercase text-center">
                Cleaning Tools Used in Move-in Move-out Cleaning
            </h2>

            <p>
                Professional cleaning services use a wide range of tools and equipment. Here’s a handy overview, categorized by their type of usage:
            </p>

            <div className="grid sm:grid-cols-2 gap-5">
                {cleaningTools.map((tool, i) => (
                <div key={i} className="rounded-xl border border-gray-200 shadow-md p-4 bg-white space-y-2">
                    <div
                    className="flex justify-between items-start cursor-pointer"
                    onClick={() => setOpenIndex(openIndex === i ? null : i)}
                    >
                    <div className="flex gap-3 items-center">
                        <span className="text-2xl">{tool.icon}</span>
                        <h3 className="text-base font-semibold">{tool.name}</h3>
                    </div>
                    <span className="text-sm text-gray-500">
                        {openIndex === i ? "▲" : "▼"}
                    </span>
                    </div>

                    {openIndex === i && (
                    <p className="text-gray-700">{tool.desc}</p>
                    )}

                    <span
                    className={`inline-block text-xs px-2 py-0.5 rounded-full font-medium ${typeColors[tool.type]}`}
                    >
                    {tool.type}
                    </span>
                </div>
                ))}
            </div>

            <p className="pt-4">
                These are some of the essential tools used by professional house cleaners. Depending on your home’s needs and cleaning service type, the exact tools may vary.
            </p>
        </section>   
        <BlogsList blogs={houseKeepingBlogs} wpPosts={[]} wpNewPosts={wpNewPosts}/>     
        <AnimatePresence>
            {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
        </AnimatePresence>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}